import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: '¿Necesito ser ciudadana o residente para usar esto?',
    answer: 'No. El sistema de crédito en USA funciona igual si tienes SSN o ITIN. Las leyes de protección al consumidor (FCRA) te protegen sin importar tu estatus migratorio.'
  }, {
    question: '¿Cuánto tiempo toma ver resultados?',
    answer: 'Por ley, los burós tienen 30 días para responder a tus disputas. Muchos de nuestros usuarios ven sus primeros cambios positivos (eliminación de cuentas, subida de puntos) en los primeros 35-45 días.'
  }, {
    question: '¿Es esto legal?',
    answer: "100% Legal. Estamos utilizando la 'Fair Credit Reporting Act' (FCRA), una ley federal que te da el derecho de cuestionar la validez de cualquier cuenta en tu reporte. Si ellos no pueden probarlo, deben borrarlo."
  }, {
    question: '¿Qué pasa si no sé mucho de computadoras?',
    answer: 'El sistema está diseñado para ser simple. Si puedes enviar un correo electrónico o escribir una carta, puedes hacer esto. Te damos las plantillas exactas, solo tienes que llenar los espacios en blanco.'
  }];
  return <section className="py-12 md:py-20 bg-white" data-id="element-1">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-navy text-center mb-8 md:mb-12" data-id="element-3">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-3" data-id="element-4">
          {faqs.map((faq, index) => <div key={index} className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-5">
              <button className="w-full flex items-center justify-between p-4 md:p-6 bg-white hover:bg-gray-50 transition-colors text-left gap-3" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-6">
                <span className="font-bold text-navy text-sm md:text-lg" data-id="element-7">
                  {faq.question}
                </span>
                {openIndex === index ? <MinusIcon className="w-4 h-4 text-gold flex-shrink-0" data-id="element-8" /> : <PlusIcon className="w-4 h-4 text-gold flex-shrink-0" data-id="element-9" />}
              </button>

              {openIndex === index && <div className="px-4 pb-4 md:px-6 md:pb-6 bg-white text-gray-600 text-sm md:text-base leading-relaxed border-t border-gray-100 pt-3" data-id="element-10">
                  {faq.answer}
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}